<template>
  <aside class="side-menu">
    <nav>
      <ul>
        <!-- 商品管理メニュー -->
        <li class="menu-group">
          <div class="menu-group-header" @click="toggleMenu('products')">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-box"></i>
              <span>商品管理</span>
            </div>
          </div>
          <transition name="slide">
            <ul v-if="expandedMenus.products" class="submenu">
              <li>
                <router-link to="/products/register" class="menu-item">
                  <span>商品登録</span>
                </router-link>
              </li>
              <li>
                <router-link to="/products" class="menu-item">
                  <span>商品一覧</span>
                </router-link>
              </li>
              <li>
                <router-link to="/products/barcode" class="menu-item">
                  <span>バーコード指定商品一覧</span>
                </router-link>
              </li>
              <li>
                <router-link to="/products/manufacturers" class="menu-item">
                  <span>メーカー管理</span>
                </router-link>
              </li>
            </ul>
          </transition>
        </li>

        <!-- 価格操作管理メニュー -->
        <li class="menu-group">
          <div class="menu-group-header" @click="toggleMenu('price')">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-tag"></i>
              <span>価格操作管理</span>
            </div>
          </div>
          <transition name="slide">
            <ul v-if="expandedMenus.price" class="submenu">
              <li>
                <router-link to="/price/increase" class="menu-item">
                  <span>値上げ率一覧</span>
                </router-link>
              </li>
              <li>
                <router-link to="/price/decrease" class="menu-item">
                  <span>値下げ率一覧</span>
                </router-link>
              </li>
            </ul>
          </transition>
        </li>

        <!-- 店舗移動管理メニュー -->
        <li class="menu-group">
          <div class="menu-group-header" @click="toggleMenu('store')">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-store"></i>
              <span>店舗移動管理</span>
            </div>
          </div>
          <transition name="slide">
            <ul v-if="expandedMenus.store" class="submenu">
              <li>
                <router-link to="/store/transfer/register" class="menu-item">
                  <span>店舗移動開始登録</span>
                </router-link>
              </li>
              <li>
                <router-link to="/store/transfer" class="menu-item">
                  <span>店舗移動一覧</span>
                </router-link>
              </li>
            </ul>
          </transition>
        </li>

        <!-- 買取査定管理メニュー -->
        <li class="menu-group">
          <div class="menu-group-header" @click="toggleMenu('purchase')">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-hand-holding-usd"></i>
              <span>買取査定管理</span>
            </div>
          </div>
          <transition name="slide">
            <ul v-if="expandedMenus.purchase" class="submenu">
              <li>
                <router-link to="/purchase/register" class="menu-item">
                  <span>査定登録</span>
                </router-link>
              </li>
              <li>
                <router-link to="/purchase/history" class="menu-item">
                  <span>買取履歴一覧</span>
                </router-link>
              </li>
            </ul>
          </transition>
        </li>

        <!-- 棚卸管理メニュー -->
        <li class="menu-group">
          <div class="menu-group-header" @click="toggleMenu('inventory')">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-clipboard-list"></i>
              <span>棚卸管理</span>
            </div>
          </div>
          <transition name="slide">
            <ul v-if="expandedMenus.inventory" class="submenu">
              <li>
                <router-link to="/inventory/start/register" class="menu-item">
                  <span>棚卸開始登録</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventory" class="menu-item">
                  <span>棚卸一覧</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventory/implementation" class="menu-item">
                  <span>実施棚卸</span>
                </router-link>
              </li>
              <li>
                <router-link to="/inventory/category" class="menu-item">
                  <span>棚卸カテゴリ管理</span>
                </router-link>
              </li>
            </ul>
          </transition>
        </li>

        <!-- 売上管理メニュー -->
        <li class="menu-group">
          <div class="menu-group-header" @click="toggleMenu('sales')">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-chart-line"></i>
              <span>売上管理</span>
            </div>
          </div>
          <transition name="slide">
            <ul v-if="expandedMenus.sales" class="submenu">
              <li>
                <router-link to="/sales" class="menu-item">
                  <span>売上管理</span>
                </router-link>
              </li>
            </ul>
          </transition>
        </li>

        <!-- ログ管理メニュー -->
        <li class="menu-group">
          <div class="menu-group-header" @click="toggleMenu('logs')">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-file-alt"></i>
              <span>ログ管理</span>
            </div>
          </div>
          <transition name="slide">
            <ul v-if="expandedMenus.logs" class="submenu">
              <li>
                <router-link to="/logs/event" class="menu-item">
                  <span>イベントログ</span>
                </router-link>
              </li>
            </ul>
          </transition>
        </li>

        <!-- 外部連携テストメニューは削除 -->

        <!-- アカウント管理メニュー -->
        <li class="menu-group">
          <div class="menu-group-header" @click="toggleMenu('accounts')">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-user"></i>
              <span>アカウント管理</span>
            </div>
          </div>
          <transition name="slide">
            <ul v-if="expandedMenus.accounts" class="submenu">
              <li>
                <router-link to="/accounts" class="menu-item">
                  <span>アカウント一覧</span>
                </router-link>
              </li>
            </ul>
          </transition>
        </li>

        <!-- 自動印刷スイッチ -->
        <li class="menu-group">
          <div class="menu-group-header print-menu-header">
            <div class="menu-icon-text">
              <i class="menu-icon fas fa-print"></i>
              <span>自動印刷</span>
            </div>
            <div class="print-toggle-container">
              <label class="print-toggle-switch">
                <input 
                  type="checkbox" 
                  :checked="printButtonEnabled" 
                  @change="togglePrintButton"
                />
                <span class="print-toggle-slider"></span>
              </label>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import printEventService from '../../services/printEventService'
import store from '../../store'

export default {
  name: 'SideMenu',
  data() {
    return {
      expandedMenus: {
        products: false,
        price: false,
        store: false,
        purchase: false,
        inventory: false,
        sales: false,
        logs: false,
        external: false,
        accounts: false
      }
    }
  },
  computed: {
    printButtonEnabled: {
      get() {
        return sessionStorage.getItem('printButtonEnabled') === 'true'; 
      },
      set(value) { 
        const _value = value === true ? 'true' : 'false'
        sessionStorage.setItem('printButtonEnabled', _value); 
        this.$forceUpdate();
      }
    }
  },
  methods: {
    toggleMenu(menuId) {
      // 排他的に開閉するように修正
      const wasExpanded = this.expandedMenus[menuId];
      // すべてのメニューを閉じる
      Object.keys(this.expandedMenus).forEach(key => {
        this.expandedMenus[key] = false;
      });
      // クリックしたメニューが閉じていた場合のみ開く
      if (!wasExpanded) {
        this.expandedMenus[menuId] = true;
      }
    },
    async togglePrintButton() {
      try {
        const printButtonEnabled = sessionStorage.getItem('printButtonEnabled') === 'true'
        if (!printButtonEnabled) {
          // ONにする場合：SSE接続を確立
          const user = store.getters['auth/currentUser'];
          await printEventService.connect(user.storeId);

          this.printButtonEnabled = true;

        } else {
          // OFFにする場合：SSE接続を切断
          printEventService.disconnect();
          this.printButtonEnabled = false;
        }
      } catch (error) {
        console.error('印刷ボタンの切り替えに失敗しました:', error);
        // エラーが発生した場合は状態をOFFに戻し、接続をクリーンアップ
        printEventService.disconnect();
        this.printButtonEnabled = false;
      }
    }
  },
  mounted() {
    // 初期状態ではすべてのメニューを閉じておく
    // 現在のパスに基づいて適切なメニューを開く場合はここで設定
  }
}
</script>

<style scoped>
.side-menu {
  background-color: #e4e4e4;
  width: 220px;
  min-width: 200px;
  height: 100%;
  color: white;
}

.side-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-group {
  margin-bottom: 3px;
  background-color: #195983;
}

.menu-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  color: white;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;
  font-size: 18px;
}

.menu-icon-text {
  display: flex;
  align-items: center;
  padding-left: 1rem; /* メニューテキストの左側のパディング */
}

.menu-icon {
  margin-right: 16px; /* アイコンの間隔を16pxに変更 */
  width: 20px;
  text-align: center;
  display: inline-block; /* アイコンを表示する */
  font-size: 18px; /* フォントサイズを18pxに設定 */
}

.menu-group-header:hover {
  background-color: #1e6ca3;
}

/* toggle-icon styles removed as requested */

.submenu {
  background-color: #FFF;
  font-weight: bold;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 17px;
  color: #195983;
  text-decoration: none;
  transition: background-color 0.3s;
  font-weight: bold;
}

.menu-item:hover {
  background-color: #ffed27;
  color: #195983;
}

.menu-item.router-link-active {
  color: #195983;
  font-weight: bold;
  background-color: transparent; /* アクティブな子メニューの背景色を削除 */
}

/* アニメーション */
.slide-enter-active, .slide-leave-active {
  transition: all 0.6s ease; /* アニメーションをゆっくりに変更 */
  max-height: 200px;
  overflow: hidden;
}

.slide-enter-from, .slide-leave-to {
  max-height: 0;
  opacity: 0;
}

/* 印刷メニューのスタイル */
.print-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  color: white;
  font-weight: bold;
  font-size: 18px;
}

.print-menu-header:hover {
  background-color: #1e6ca3;
}

.print-toggle-container {
  padding-right: 1rem;
}

/* 印刷トグルスイッチのスタイル */
.print-toggle-switch {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.print-toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.print-toggle-slider {
  position: relative;
  width: 40px;
  height: 20px;
  background-color: #ccc;
  border-radius: 34px;
  transition: .4s;
  cursor: pointer;
}

.print-toggle-slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  border-radius: 50%;
  transition: .4s;
}

.print-toggle-switch input:checked + .print-toggle-slider {
  background-color: #4CD964;
}

.print-toggle-switch input:checked + .print-toggle-slider:before {
  transform: translateX(20px);
}
</style>
